(function($, FUNCTIONS, cssua){
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';
	const slideSpeed = '400';

	FUNCTIONS = {
		va: {
			pathname: location.pathname,
			device: {
				desktop: 1024,
				sp: 768
			},
			window: {
				width: $(window).width(),
				height: $(window).height()
			}
		},
		slides(){
			$('.product-slide01').slick({
				arrows: true,
				autoplay: false,
				slidesToShow: 4,
				slidesToScroll: 4,
				loop: true,
				infinite: true,
				dots: true,
				speed: 200,
				responsive: [
					{
					breakpoint: 768,
						settings: {
						arrows: true,
						autoplay: false,
						slidesToShow: 1,
						slidesToScroll: 1,
						centerMode: true,
						loop: true,
						infinite: true,
						dots: true,
					    centerPadding: '10%'
					  }
					}
				]
			});
			$('.product-slide02').slick({
				arrows: true,
				autoplay: false,
				slidesToShow: 4,
				slidesToScroll: 4,
				loop: true,
				infinite: true,
				dots: true,
				speed: 200,
				responsive: [
					{
					breakpoint: 768,
						settings: {
						arrows: true,
						autoplay: false,
						slidesToShow: 1,
						slidesToScroll: 1,
						centerMode: true,
						loop: true,
						infinite: true,
						dots: true,
					    centerPadding: '10%'
					  }
					}
				]
			});
			$('.product-slide03').slick({
				arrows: false,
				autoplay: false,
				slidesToShow: 4,
				loop: false,
				infinite: true,
				dots: false,
				speed: 200,
				responsive: [
					{
					breakpoint: 768,
						settings: {
						arrows: true,
						autoplay: false,
						slidesToShow: 1,
						slidesToScroll: 1,
						centerMode: true,
						loop: true,
						infinite: true,
						dots: true,
					    centerPadding: '10%'
					  }
					}
				]
			});
		},
		modal() {
			var scrollTopNow;

			$('.js-product-modal-btn').on('click', function(event){
				var title = $(this).data('title');
				var imgs = $(this).data('imgs');
				var lead = $(this).data('lead');
				var link = $(this).data('link');

				$('.product-modal-overlay').addClass(a);

				if($(this).hasClass('js-product-modal-btn-blank')) {
					$('.product-modal-content').html(
						'<ul class="pure-g product-item">' +
							'<li class="pure-u-1-4 pure-u-md-1-1 product-item-left">' +
								'<h3 class="product-item-title ff_mincho">'+ title +'</h3>' +
								'<img src="/ladies/rn-images/product/modal/'+ imgs +'_logo_pc.jpg" class="width-u-100" data-view="pc tablet">' +
								'<img src="/ladies/rn-images/product/modal/'+ imgs +'_logo_sp.jpg" class="width-u-100" data-view="sp">' +
							'</li>' +
							'<li class="pure-u-3-4 pure-u-md-1-1 product-item-right">' +
								'<div class="product-item-icon">' +
									'<img src="/ladies/rn-images/product/modal/'+ imgs +'_icons_pc.jpg" class="width-u-100" data-view="pc tablet">' +
									'<img src="/ladies/rn-images/product/modal/'+ imgs +'_icons_sp.jpg" class="width-u-100" data-view="sp">' +
								'</div>' +
								'<ul class="pure-g">' +
									'<li class="pure-u-2-3 pure-u-md-1-1">' +
										'<p class="fs_middle_s">'+ lead +'</p>' +
									'</li>' +
									'<li class="pure-u-1-3 pure-u-md-1-1">' +
										'<div class="product-item-links">' +
											'<a href="'+ link +'" class="product-item-links-btn" target="_blank">» もっと詳しく見る</a>' +
										'</div>' +
									'</li>' +
								'</ul>' +
							'</li>' +
						'</ul>'
					);
				}else {
					$('.product-modal-content').html(
						'<ul class="pure-g product-item">' +
							'<li class="pure-u-1-4 pure-u-md-1-1 product-item-left">' +
								'<h3 class="product-item-title ff_mincho">'+ title +'</h3>' +
								'<img src="/ladies/rn-images/product/modal/'+ imgs +'_logo_pc.jpg" class="width-u-100" data-view="pc tablet">' +
								'<img src="/ladies/rn-images/product/modal/'+ imgs +'_logo_sp.jpg" class="width-u-100" data-view="sp">' +
							'</li>' +
							'<li class="pure-u-3-4 pure-u-md-1-1 product-item-right">' +
								'<div class="product-item-icon">' +
									'<img src="/ladies/rn-images/product/modal/'+ imgs +'_icons_pc.jpg" class="width-u-100" data-view="pc tablet">' +
									'<img src="/ladies/rn-images/product/modal/'+ imgs +'_icons_sp.jpg" class="width-u-100" data-view="sp">' +
								'</div>' +
								'<ul class="pure-g">' +
									'<li class="pure-u-2-3 pure-u-md-1-1">' +
										'<p class="fs_middle_s">'+ lead +'</p>' +
									'</li>' +
									'<li class="pure-u-1-3 pure-u-md-1-1">' +
										'<div class="product-item-links">' +
											'<a href="'+ link +'" class="product-item-links-btn">» もっと詳しく見る</a>' +
										'</div>' +
									'</li>' +
								'</ul>' +
							'</li>' +
						'</ul>'
					);
				}

				scrollTopNow = $(window).scrollTop();

				$('body').addClass(f);
				$( '.container' ).css({
					position: 'fixed',
					width: '100%',
					top: -1 * scrollTopNow,
					left: 0
				});
				event.preventDefault();
			});

			$('.product-modal-closeBtn').on('click', function(event){
				$('.product-modal-content').html('');
				$('.product-modal-overlay').removeClass(a);
				$('body').removeClass(f);
				$( '.container' ).css( {
					position: 'static',
				} );
				$(window).scrollTop(scrollTopNow);
				event.preventDefault();
			});

			$('.product-modal-back').on('click', function(event){
				$('.product-modal-content').html('');
				$('.product-modal-overlay').removeClass(a);
				$('body').removeClass(f);
				$( '.container' ).css( {
					position: 'static',
				} );
				$(window).scrollTop(scrollTopNow);
				event.preventDefault();
			});
		},
		change() {
			if(FUNCTIONS.va.window.width < 980) {
				var flag = false;
				$('.js-imgChange').on('click', function(event){
					if(!flag) {
						$(this).addClass(a);
						flag = true;
					}else {
						$(this).removeClass(a);
						flag = false;
					}
				});
			}
		},
		loadDelayScript(){
			var _this = this;
			_this.slides();
			_this.modal();
			_this.change();
		}
	};

	$(() => FUNCTIONS.loadDelayScript());
})(window.jQuery, window.FUNCTIONS, window.cssua);